/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type PortraitMaleIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let PortraitMaleIcon: NessieFunctionComponent<PortraitMaleIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.53 17.422c-2.891-1.12-6.108-2.494-6.361-3.362v-.903c.614-.615 1.084-1.482 1.337-2.458.361-.253.614-.687.614-1.193 0-.361-.144-.687-.325-.94V6.542C15.795 4.446 14.64 3 11.964 3 9.36 3 8.133 4.446 8.133 6.542v2.024a1.416 1.416 0 00-.326.94c0 .506.253.94.615 1.193.289 1.012.759 1.843 1.337 2.458v.903c-.253.868-3.47 2.241-6.361 3.362a.633.633 0 00-.398.614v2.277c0 .362.29.65.65.65h16.7c.36 0 .65-.288.65-.65v-2.277c-.072-.289-.217-.506-.47-.614z"
          />
          <mask maskUnits="userSpaceOnUse" x={3} y={3} width={18} height={18}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.53 17.422c-2.891-1.12-6.108-2.494-6.361-3.362v-.903c.614-.615 1.084-1.482 1.337-2.458.361-.253.614-.687.614-1.193 0-.361-.144-.687-.325-.94V6.542C15.795 4.446 14.64 3 11.964 3 9.36 3 8.133 4.446 8.133 6.542v2.024a1.416 1.416 0 00-.326.94c0 .506.253.94.615 1.193.289 1.012.759 1.843 1.337 2.458v.903c-.253.868-3.47 2.241-6.361 3.362a.633.633 0 00-.398.614v2.277c0 .362.29.65.65.65h16.7c.36 0 .65-.288.65-.65v-2.277c-.072-.289-.217-.506-.47-.614z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
PortraitMaleIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  PortraitMaleIcon = nessiePropCheckerWrapper(PortraitMaleIcon);
}

export default PortraitMaleIcon;
